// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoUnavailable-cls1_L4-","cls2":"VideoUnavailable-cls2_4ph VideoUnavailable-cls1_L4-"};